module.exports = __webpack_public_path__ + "static/media/smartphone.aba77895.svg";